import http from "../../backend/http.js";

async function selectTag(page = 1, rowsPerPage = 9, search = "") {
  try {
    const response = await http.get("tags", {
      params: {
        page,
        pageSize: rowsPerPage,
        searchTerm: search,
      },
    });
    return response.data;
  } catch (err) {
    throw err;
  }
}

async function createTag(tag) {
  try {
    const response = await http.post("tags", tag);
    return response.data;
  } catch (err) {
    throw err;
  }
}

async function updateTag(id, tag) {
  try {
    const response = await http.patch(`tags/${id}`, { title: tag });
    return response;
  } catch (err) {
    throw err;
  }
}

async function getTag(id) {
  try {
    const response = await http.get(`tags/${id}`);
    return response.data;
  } catch (err) {
    throw err;
  }
}

export { selectTag, createTag, updateTag, getTag };
